import { SqrtPriceMath } from "@uniswap/v3-sdk"

import { toBigInt, toJSBI } from "./jsbi-bigint"

export function getAmount0Delta(args: {
  sqrtRatioAX96: bigint
  sqrtRatioBX96: bigint
  liquidity: bigint
  roundUp: boolean
}): bigint {
  return toBigInt(
    SqrtPriceMath.getAmount0Delta(
      toJSBI(args.sqrtRatioAX96),
      toJSBI(args.sqrtRatioBX96),
      toJSBI(args.liquidity),
      args.roundUp,
    ),
  )
}

export function getAmount1Delta(args: {
  sqrtRatioAX96: bigint
  sqrtRatioBX96: bigint
  liquidity: bigint
  roundUp: boolean
}): bigint {
  return toBigInt(
    SqrtPriceMath.getAmount1Delta(
      toJSBI(args.sqrtRatioAX96),
      toJSBI(args.sqrtRatioBX96),
      toJSBI(args.liquidity),
      args.roundUp,
    ),
  )
}

export function getNextSqrtPriceFromInput(args: {
  sqrtPX96: bigint
  liquidity: bigint
  amountIn: bigint
  zeroForOne: boolean
}): bigint {
  return toBigInt(
    SqrtPriceMath.getNextSqrtPriceFromInput(
      toJSBI(args.sqrtPX96),
      toJSBI(args.liquidity),
      toJSBI(args.amountIn),
      args.zeroForOne,
    ),
  )
}
